import axios from "axios";

const BASE = `${import.meta.env.REACT_APP_SITE_URL}order`;

/**
 * Where an order stands on the customer's own insurance policy: whether one
 * can be uploaded, and the policies already on the order.
 *
 * @param {number|string} orderId Order id
 * @returns {Promise}
 */
export function getStoreProtectStatus(orderId) {
  return axios.get(`${BASE}/${orderId}/store-protect`);
}

/**
 * Upload a customer's own policy. The server runs the automatic check and
 * refuses a policy that fails it unless `override` and a reason are sent.
 *
 * @param {number|string} orderId Order id
 * @param {Object} fields
 * @param {File} fields.file PDF, JPG or PNG up to 10 MB
 * @param {string} [fields.expiryDate] YYYY-MM-DD; defaults to the date read from the policy
 * @param {boolean} [fields.override] Accept the policy although the check did not pass
 * @param {string} [fields.overrideReason] Why (required with override)
 * @returns {Promise}
 */
export function uploadStoreProtectPolicy(orderId, { file, expiryDate, override, overrideReason }) {
  const form = new FormData();
  form.append("file", file);
  if (expiryDate) form.append("expiry_date", expiryDate);
  if (override) {
    form.append("override", "1");
    form.append("override_reason", overrideReason || "");
  }

  return axios.post(`${BASE}/${orderId}/store-protect/policy`, form);
}

/**
 * Address of a policy's download. Fetch through axios (downloadExport) so the
 * request carries the sign-in token.
 *
 * @param {number|string} orderId Order id
 * @param {number|string} policyId Policy id
 * @returns {string}
 */
export function storeProtectPolicyDownloadUrl(orderId, policyId) {
  return `${BASE}/store-protect/policy/${orderId}/download?policy_id=${policyId}`;
}
